// src/components/SignIn/SignIn.jsx
import { observer } from 'mobx-react';
import { isMobile } from 'is-mobile';
import { View, LoadingScreen } from '../../components';
import { useSignIn } from './hooks/useSignIn';
import SignInForm from './components/SignInForm';
import SignInImage from './components/SignInImage';
import './style.scss';
import { useEffect } from 'react';
import { useStore } from '../../stores';

const SignIn = observer(() => {
  const {
    username,
    password,
    error,
    usernameError,
    passwordError,
    isLoading,
    handleUsernameChange,
    handlePasswordChange,
    handleLogin,
    resetErrors
  } = useSignIn();

  const { uiStore } = useStore();

  // Check for session expiration parameter in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('session_expired') === 'true' && uiStore.showNotification) {
      uiStore.showNotification('Your session has expired. Please login again.', 'info');
      
      // Clean up the URL
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, [uiStore]);

  if (isMobile()) {
    return (
      <div className="mobile-signin">
        <p>Sign In Mobile - Mobile optimized view coming soon</p>
      </div>
    );
  }

  return (
    <View className="signinView">
      <div className="signInContainer">
        <SignInForm
            username={username}
            password={password}
            error={error}
            usernameError={usernameError}
            passwordError={passwordError}
            onUsernameChange={handleUsernameChange}
            onPasswordChange={handlePasswordChange}
            onLogin={handleLogin}
            onResetErrors={resetErrors}
            />
        <SignInImage />
      </div>
      
      {/* Use local loading state and ignore global loading */}
      <LoadingScreen 
        isOverLay={true} 
        show={isLoading} 
        ignoreGlobalLoading={true} 
      />
    </View>
  );
});

export default SignIn;